import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
        color: 'var(--text2)',
        background: 'var(--bg)',
        padding: 24,
      }}
    >
      <div style={{ fontSize: 64, fontWeight: 800, color: 'var(--text)' }}>404</div>
      <div>Page not found</div>
      <Link to="/" style={{ color: 'var(--accent)' }}>
        Go home
      </Link>
    </div>
  );
}
